<template>
    <div>
        <bs-card class="card-info" :icon="['fal', 'books']" :label="$t('labels.' + camelToSnake($options.name))">
            <template v-slot:header>
                <bs-button class="btn-sm btn-info" @click="create" v-if="auth.can['edit_roles']">{{ $t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.create') }) }}</bs-button>
            </template>
            <bs-table v-bind="{dataLength, loading}" :cols="2">
                <template v-slot:thead>
                    <tr>
                        <th scope="col">{{ $t('labels.name') }}</th>
                        <th scope="col"></th>
                    </tr>
                </template>
                <tr v-for="r in resources.data" :key="r.id">
                    <td>{{ r.name }}</td>
                    <td class="t2">
                        <bs-action v-if="auth.can['edit_roles']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
                        <bs-action v-if="auth.can['edit_roles']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
                <template v-slot:tfoot>
                    <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
                </template>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <tuxedo-input :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error" />
                    <checkbox-field :label="'Permissions'" :options="permissions" v-model="resource.permissions"></checkbox-field>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: $t('labels.role') }) }}
            </bs-form>
        </bs-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Roles',
  data () {
    return {
      tableRows: 10,
      page: 1,
      sort: {
        col: 'label',
        dir: 'asc'
      },
      loading: false,
      activeId: null,
      resource: {
        name: '',
        permissions: []
      },
      permissions: {
        settings: {
          name: this.$t('permits.settings'),
          children: {
            edit_users: this.$t('permits.edit_users'),
            roles: this.$t('permits.roles'),
            edit_roles: this.$t('permits.edit_roles')
          }
        },
        edit_customers: {
          name: this.$t('permits.edit_customers'),
          children: {
            customer_contacts: this.$t('permits.customer_contacts'),
            edit_customer_contacts: this.$t('permits.edit_customer_contacts'),
            customer_notes: this.$t('permits.customer_notes'),
            edit_customer_notes: this.$t('permits.edit_customer_notes'),
            customer_documents: this.$t('permits.customer_documents'),
            edit_customer_documents: this.$t('permits.edit_customer_documents'),
            customer_properties: this.$t('permits.customer_properties'),
            edit_customer_properties: this.$t('permits.edit_customer_properties')
          }
        },
        edit_lists: {
          name: this.$t('permits.edit_lists')
        },
        edit_tasks: {
          name: this.$t('permits.edit_tasks')
        },
        edit_vehicles: {
          name: this.$t('permits.edit_vehicles')
        }
      }
    }
  },
  mounted () {
    this.index(this.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.roles,
      resourceState: state => state.rolesState,
      submitting: state => state.submitting
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.tableRows - length, 0)
    }
  },
  methods: {
    applySort (val) {
      this.sort = val
      this.index()
    },
    index (page, count) {
      if (page) this.page = page
      else page = this.page
      if (count) this.tableRows = count
      else count = this.tableRows
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, params: { page: page, count: count, sort: this.sort.col, direction: this.sort.dir } }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$store.commit('axiosError', null)
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
